import { render, staticRenderFns } from "./SmartPagination.vue?vue&type=template&id=345ade38&replaceable=true&part=pagination&"
import script from "./SmartPagination.vue?vue&type=script&lang=js&"
export * from "./SmartPagination.vue?vue&type=script&lang=js&"
import style0 from "./SmartPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports